module.exports = __webpack_public_path__ + "img/avatar7.e07789e3.png";